import { Snackbar, type SnackbarProps } from "@mui/material";
import styles from "./styles.module.css";

interface Props extends SnackbarProps {
  className?: string;
}

export const AppSnackbar = ({ children, className, ...rest }: Props) => {
  return <Snackbar {...rest}>{children}</Snackbar>;
};
